.b3{overflow:hidden;}